module.exports = __webpack_public_path__ + "img/stock4.47094f59.png";